'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { Paragraph } from '../ui/paragraph';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { GoArrowRight } from 'react-icons/go';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { useState } from 'react';

export function ReferenceCard({
  reference,
  showCategory = false,
}: {
  reference: Reference;
  showCategory?: boolean;
}) {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  const allImages = [reference.image, ...(reference.images || [])].filter(Boolean);

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <div
        onClick={handleOpenGallery(allImages, 0)}
        className={cn(
          'group',
          'relative flex h-[280px] w-full cursor-pointer items-end justify-start p-4 transition-all hover:opacity-90 sm:h-[300px] sm:p-5 md:h-[320px] lg:h-[390px] lg:p-6',
        )}
      >
        <GoArrowRight
          size={32}
          className={cn(
            'absolute right-4 top-4 z-10 text-white sm:left-5 sm:top-5 lg:left-6 lg:top-6',
            'transition-all group-hover:translate-x-2',
          )}
        />
        <div className="relative z-10 flex w-full flex-col items-start justify-start gap-2 sm:gap-3">
          {showCategory && reference.categories && reference.categories.length > 0 && (
            <p className="flex h-[28px] items-center justify-center border border-white px-2 font-oswald text-sm font-medium uppercase text-white">
              {reference.categories[0].name}
            </p>
          )}
          <h4 className="font-oswald text-2xl font-bold uppercase text-white md:text-3xl lg:text-[32px]">
            {reference.name}
          </h4>
          {!!reference?.city && (
            <Paragraph color="white" className="font-medium">
              {reference.city}
            </Paragraph>
          )}
        </div>
        <div className={cn('absolute inset-0 z-[1] h-full w-full', 'ea-reference-card__overlay')} />
        <Image
          src={reference?.image?.url || ''}
          alt={resolveImageAlt(reference?.image, reference?.name)}
          width={0}
          height={0}
          className="absolute inset-0 z-0 h-full w-full object-cover object-center"
          sizes="100Vw"
        />
      </div>
    </>
  );
}
